import { __decorate } from "tslib";
import { attr, html } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../common/mixin';
export const chatStackTemplate = html `<template>
  <div class="container">
    <div class="avatar-container">
      <slot name="avatar"></slot>
    </div>
    <div class="chat-bubble-container">
      <chameleon-typography class="author-name" variant="caption-small-strong" color="type-color-default"
        >${(x) => x.authorName}</chameleon-typography
      >
      <div><slot></slot></div>
      <slot name="end"></slot>
    </div>
  </div>
</template>`;
export class ChatStackComponent extends ChameleonElementMixin(FoundationElement) {
    constructor() {
        super(...arguments);
        this.type = 'inbound';
    }
}
__decorate([
    attr({ attribute: 'author-name' })
], ChatStackComponent.prototype, "authorName", void 0);
__decorate([
    attr
], ChatStackComponent.prototype, "type", void 0);
